import { __assign } from 'tslib';
import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

var PREFIX = "BusinessFilterLayout";
var classes = {
    content: "".concat(PREFIX, "-content"),
    title: "".concat(PREFIX, "-title")
};
var StyledBusinessFilterLayout = styled(Box, {
    shouldForwardProp: function (prop) { return prop !== "active"; }
})(function (_a) {
    var _b, _c, _d;
    var theme = _a.theme, active = _a.active;
    return (__assign(__assign((_b = { backgroundColor: theme.palette.grey[100], minHeight: "100%", width: 0, transitionProperty: "width", 
            // Material UI Recommand a 250ms for opening and 200ms for closing
            // https://material.io/design/motion/speed.html#duration
            transitionDuration: active ? ".25s" : ".2s", transitionTimingFunction: "ease-out", overflow: "hidden" }, _b[theme.breakpoints.up("xs")] = {
        maxWidth: "75vw"
    }, _b[theme.breakpoints.up("sm")] = {
        maxWidth: "30vw"
    }, _b[theme.breakpoints.up("md")] = {
        maxWidth: "25vw"
    }, _b), (active && { width: theme.spacing(35) })), (_c = {}, _c["& .".concat(classes.content)] = (_d = {},
        // duplicate the maxWidth on breakpoint so
        // the content will not reflow
        _d[theme.breakpoints.up("xs")] = {
            maxWidth: "75vw"
        },
        _d[theme.breakpoints.up("sm")] = {
            maxWidth: "30vw"
        },
        _d[theme.breakpoints.up("md")] = {
            maxWidth: "25vw"
        },
        _d.width = theme.spacing(35),
        _d.overflowX = "hidden",
        _d), _c["& .".concat(classes.title)] = {
        marginBottom: theme.spacing(2)
    }, _c)));
});

export { classes, StyledBusinessFilterLayout as default };
//# sourceMappingURL=index.styled.js.map
